<template>
  <div
    id="upsell-display"
    class="onboarding-content tw-pb-36 tw-block md:tw-flex lg:tw-block tw-px-4 md:tw-px-0 tw-bg-[#F3F3F3]"
    :class="['F3v2'].includes(onboardingVariant) ?'tw-bg-[#FFFFFF]' : 'tw-bg-[#F3F3F3]'"
  >
    <portal to="onboarding-upsell-banner">
      <div
        class="tw-bg-[#1A6A72] tw-text-center tw-text-white tw-py-3 tw-fixed tw-top-0 tw-left-0 tw-right-0 tw-z-[200] onboarding-upsell-banner"
        :class="[
          ['F3v1', 'F3v2'].includes(onboardingVariant)
            ? 'tw-text-[20px] xl:tw-text-[32px]'
            : 'tw-text-lg'
        ]"
      >
        <template v-if="upsellIndex === 0">
          <template v-if="['F3v1', 'F3v2'].includes(onboardingVariant)">
            New patient offer, available right now only!
          </template>
          <template v-else>
            Offer available <span class="tw-font-bold">right now</span> only!
          </template>
        </template>
        <template v-else>
          <template v-if="['F3v1', 'F3v2'].includes(onboardingVariant)">
            New patient offer, available right now only!
          </template>
          <template v-else-if="['E1', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)">
            Offer available <span class="tw-font-bold">right now</span> only!
          </template>
          <template v-else>
            Offer available for a <span class="tw-font-bold">limited time</span> only!
          </template>
        </template>
      </div>
    </portal>
    <div
      class="tw-mt-40 tw-max-w-[400px] md:tw-max-w-[500px]  tw-mx-auto"
      :class="{
        'lg:tw-max-w-[600px]' : ['F3v1', 'F3v2'].includes(onboardingVariant),
        'tw-pb-16': !['F3v1', 'F3v2'].includes(onboardingVariant),
      }"
    >
      <CarouselSlider
        ref="upsellCarousel"
        :has-dots="false"
        :active="false"
        animation="opacity"
      >
        <CarouselItem
          v-for="(product, i) in upsellProductList"
          :key="product.id"
        >
          <SelectProductUpsellV2
            :product="product"
            :idx="i"
            :current="upsellIndex"
          />
        </CarouselItem>
      </CarouselSlider>
    </div>

    <portal to="back">
      <b-button
        v-if="upsellIndex > 0"
        class="back-btn"
        size="lg"
        variant="link"
        style="min-width: inherit"
        @click="prev"
      >
        <!-- Back icon -->
        <svg
          width="19"
          height="15"
          viewBox="0 0 19 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.25 7.58594C0.25 7.32149 0.365476 7.08816 0.596428 6.88594L6.9806 0.877604C7.19506 0.68316 7.43839 0.585938 7.71058 0.585938C7.98277 0.585938 8.2096 0.671493 8.39106 0.842604C8.58077 1.01372 8.67563 1.23149 8.67563 1.49594C8.67563 1.62038 8.65088 1.74094 8.60139 1.8576C8.56015 1.97427 8.49417 2.07149 8.40343 2.14927L6.69604 3.8176L2.51416 7.37594L2.29145 6.8626L5.58252 6.64094H17.2621C17.559 6.64094 17.7982 6.73038 17.9797 6.90927C18.1612 7.08816 18.2519 7.31372 18.2519 7.58594C18.2519 7.85816 18.1612 8.08372 17.9797 8.2626C17.7982 8.44149 17.559 8.53094 17.2621 8.53094H5.58252L2.29145 8.30927L2.51416 7.8076L6.69604 11.3543L8.40343 13.0226C8.49417 13.1004 8.56015 13.1976 8.60139 13.3143C8.65088 13.4309 8.67563 13.5515 8.67563 13.6759C8.67563 13.9404 8.58077 14.1582 8.39106 14.3293C8.2096 14.5004 7.98277 14.5859 7.71058 14.5859C7.43839 14.5859 7.19506 14.4887 6.9806 14.2943L0.596428 8.28594C0.365476 8.08372 0.25 7.85038 0.25 7.58594Z"
            fill="#19191C"
          />
        </svg>
      </b-button>
    </portal>

    <!-- @upsell-processing="onAddUpsellProcessing"
          @upsell-change="onMultipleUpsellChange"
          @upsell-remove="onMultipleUpsellRemove"
          @error="onUpsellError" -->

    <OnboardingCTAContainer>
      <div class="tw-flex tw-flex-col tw-w-full">
        <div>
          <template v-if="['F3v1', 'F3v2'].includes(onboardingVariant)">
            <button
              v-if="isSelectedProductUpsell"
              class="tw-bg-white md:tw-w-[425px] tw-border !tw-text-[#312849] !tw-border-[#312849] focus:tw-shadow-none tw-tracking-[2px] tw-flex tw-items-center tw-justify-center tw-gap-2 tw-px-[10px] tw-py-[10px] tw-max-w-[425px] tw-mx-auto tw-rounded-[12px] tw-font-atten tw-font-bold tw-uppercase"
              :disabled="isProcessing"
              @click="onRemoveUpsellSelected"
            >
              - Remove from treatment plan
            </button>
            <button
              v-else
              class="tw-bg-[#AF8EFF] tw-uppercase tw-font-atten-medium md:tw-w-[326px] tw-text-white tw-border-[#AF8EFF] focus:tw-shadow-none tw-tracking-[2px] tw-flex tw-items-center tw-justify-center tw-gap-2 tw-px-[10px] tw-py-[10px] tw-max-w-[425px] tw-mx-auto tw-rounded-[12px] tw-font-bold"
              :disabled="isProcessing"
              @click="onUpsellSelected"
            >
              <span class="tw-inline-block tw-mb-0.5">+</span> Add to treatment plan
            </button>
          </template>
          <b-button
            v-else
            class="focus:tw-shadow-none slight-rounded tw-flex tw-items-center tw-justify-center tw-gap-2 tw-max-w-[425px] tw-mx-auto xl:tw-text-base"
            :class="[ isSelectedProductUpsell
              ? 'tw-bg-[#AF8EFF] tw-text-white tw-border-[#AF8EFF]'
              : 'tw-bg-white tw-text-[#AF8EFF] tw-border-[#AF8EFF]'
            ]"
            pill
            block
            :disabled="isProcessing"
            @click="onUpsellSelected"
          >
            <svg
              v-if="isSelected"
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="10.4766"
                cy="10.5"
                r="9.5"
                fill="white"
                stroke="white"
              />
              <path
                d="M6.28144 11.5058L8.40949 13.6339L14.6684 7.375"
                stroke="#AF8EFF"
                stroke-width="1.24611"
                stroke-linecap="round"
              />
            </svg>
            <svg
              v-else
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="10.2695"
                cy="10.5"
                r="9.5"
                stroke="#AF8EFF"
              />
            </svg>
            Add to treatment plan
          </b-button>
        </div>

        <div class="tw-text-center tw-mt-4 tw-w-full">
          <button
            class="tw-inline-block tw-bg-white tw-text-[#787878] tw-border-[#787878] tw-cursor-pointer"
            :class="[['F3v1', 'F3v2'].includes(onboardingVariant) && 'tw-text-lg md:!tw-text-[26px]']"
            :disabled="isProcessing"
            @click="onNoThanks"
          >
            No thanks, maybe later  →
            <div
              v-if="['F3v1', 'F3v2'].includes(onboardingVariant)"
              class="tw-h-[1px] tw-width-full tw-bg-[#787878] tw-mt-1"
            ></div>
          </button>
        </div>
      </div>
    </OnboardingCTAContainer>
  </div>
</template>

<script>
import { AnalyticsService } from '@/services/analytics.service';
import SelectProductUpsellV2 from '@/components/onboarding/checkout/SelectProductUpsellV2.vue';
import CarouselSlider from '@corefront/components-v2/Carousel/CarouselSlider.vue';
import CarouselItem from '@corefront/components-v2/Carousel/CarouselItem.vue';
import OnboardingCTAContainer from '@/components/onboarding/OnboardingCTAContainer';
import { mapState, mapGetters } from 'vuex';
import { UPSELL_PROMO_CODES } from '@/constants/promoCodes'
import analyticsMixin from '@/mixins/analytics';

export default {
  name: 'Upsell',
  components: {
    SelectProductUpsellV2,
    CarouselSlider,
    CarouselItem,
    OnboardingCTAContainer,
  },
  mixins: [analyticsMixin],
  props: {
    patientId: {
      type: String,
      default: ''
    }
  },
  data(){
    return {
      isSelected: false,
      isProcessing: false,
      selectedUpsell: [],
      upsellIndex: 0
    }
  },
  computed: {
    ...mapState('onboarding', ['onboardingPatient']),
    ...mapGetters('configuration', ['isDeepSleepUpsellEnabled']),
    onboardingVariant() {
      return this.onboardingPatient?.flow_variant;
    },
    upsellProductList() {
      return (this.$store.state.upsell.availableDashboardUpsell || []).filter(
        product =>
          product?.upsellcode !== 'BLOSSOM' &&
          (this.isDeepSleepUpsellEnabled || product?.upsellcode !== 'DEEPSLEEP')
      );
    },
    isSelectedProductUpsell() {
      const productData = this.upsellProductList[this.upsellIndex];
      const isSelected = this.selectedUpsell.find(product => {
        return productData.productid === product.productid;
      });

      return !!isSelected
    },
  },
  async created() {
    await this.$store.dispatch('upsell/fetchAvailableDashboardUpsell');
  },
  methods: {
    async onRemoveUpsellSelected() {
      if (this.isProcessing) return;
      this.isProcessing = true;

      try {
        const productData = this.upsellProductList[this.upsellIndex];

        const isSelected = this.selectedUpsell.find(product => {
          return productData.productid === product.productid;
        });

        if (!isSelected) {
          console.warn('No upsell selected to remove');
          return;
        }
        const request = await this.$store.dispatch(
          'upsell/denyUpsell',
          { upsellId: isSelected.upsellid }
        );
        if (request?.success) {
          this.$delete(this.selectedUpsell, this.upsellIndex);
          this.isSelected = false;
        }
      } catch (error) {
        console.error('Error in onRemoveUpsellSelected:', error);
      } finally {
        this.isProcessing = false;
      }
    },
    async trackUpsellOnboarding() {
      const acceptedUpsells = this.selectedUpsell.filter(Boolean);
      for (const upsell of acceptedUpsells) {
        const productData = this.upsellProductList.find(p => p.id === upsell.productid);
        const pricing = productData.pricing?.[0];
        const { data } = await AnalyticsService.getProductFirstPurchase(this.patientId, pricing.product)
        const upsellPriceConverted = Number(productData.metadata.onboarding_upsellprice.replace(/\$/g, ''));
  
        this.$_analytics_track('Upsell Added to Order', {
          productid: productData.id,
          productname: productData?.metadata?.previousproductname || productData.name,
          triggeredfrom: 'onboarding',
          firstpurchase: data?.firstPurchase || false,
          value: upsellPriceConverted,
        })
      }
    },
    async onUpsellSelected() {
      if (this.isProcessing) return;
      this.isProcessing = true;

      try {
        const productData = this.upsellProductList[this.upsellIndex];
        const pricing = productData.pricing?.[0];

        if (!pricing) {
          console.error('No pricing data found for upsell product');
          return;
        }

        let addUpsellResponse;
        if (!productData?.upsellid) {
          addUpsellResponse = await this.$store.dispatch(
            'upsell/addUpsell',
            { product: productData.upsellcode }
          );
        }

        this.$set(this.selectedUpsell, this.upsellIndex, {
          upsellid: addUpsellResponse?.data?.id || productData.upsellid,
          productid: pricing.product,
          pricingid: pricing.id,
          triggeredfrom: 'onboarding',
          coupon: productData?.bfcm || productData.upsellcode === 'DEEPSLEEP' ? UPSELL_PROMO_CODES[productData.upsellcode] : undefined
        });

        if (this.upsellIndex === this.upsellProductList.length - 1) {
          await this.$store.dispatch(
            'upsell/acceptMultipleUpsell',
            this.selectedUpsell.filter(Boolean)
          );
          this.trackUpsellOnboarding();
          this.$emit('nextStep');
          return;
        }

        await new Promise(resolve => setTimeout(resolve, 1000));
        this.upsellIndex += 1;
        this.next();
      } catch (error) {
        console.error('Error in onUpsellSelected:', error);
      } finally {
        this.isProcessing = false;
      }
    }, 

    async onNoThanks() {
      if (this.isProcessing) return;
      this.isProcessing = true;

      if (this.upsellIndex === this.upsellProductList.length - 1) {
        await this.$store.dispatch(
          'upsell/acceptMultipleUpsell',
          this.selectedUpsell.filter(Boolean)
        );
        this.trackUpsellOnboarding();
        this.$emit('nextStep');
      } else {
        this.$delete(this.selectedUpsell, this.upsellIndex);
        this.upsellIndex += 1;
        this.next();
      }

      this.isProcessing = false;
    },
    next() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.$refs.upsellCarousel.next();
    },
    prev() {
      this.upsellIndex -= 1;
      if (!['F3v1', 'F3v2'].includes(this.onboardingVariant)){
        this.selectedUpsell.pop();
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.$refs.upsellCarousel.prev();
    },
  }
};
</script>

<style>
.onboarding-upsell-banner {
  margin-top: 66px;
}

@media (min-width: 769px) {
  .onboarding-upsell-banner {
    margin-top: 72px;
  }
}

@media (min-width: 993px) {
  .onboarding-upsell-banner {
    margin-top: 80px;
  }
}
</style>